import {setupResearchReports} from "./search";

$(() => {
    //setupResearchReports();
})